import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import { IconSearch, IconTrash, IconEdit, IconPlus } from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
  MRT_Row,
} from "mantine-react-table";
import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Title,
  Tooltip,
} from "@mantine/core";
import { _localization } from "../../config/location";
import { RoleModelQuery } from "../../model/RolesModel";
import {
  pageTable,
  repositorySign,
  styleTable,
} from "../../_base/_const/_constVar";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import RolesEditView from "./RolesEditView";
import { RoleModel } from "../../model/RoleModel";
import RolesAddView from "./RolesAddView";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";

const RolesTable = () => {
  const [data, setData] = useState<RoleModelQuery[]>([]);
  const [dataSearch, setDataSearch] = useState<RoleModelQuery[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  // Table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 100,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const _span = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);

  const search: any = {
    keySearch: "",
  };

  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    try {
      const baseUrl = "/api/v1/Role/get-all";

      const url = `${baseUrl}`;
      const response: any = await repositorySign.get<
        MessageResponse<RoleModelQuery[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setDataSearch(dataList);
        setRowCount(response.totalCount);

        // await dataOrderTypeSelect();
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  const handleSearch = () => {
    const keySearch = form.getValues().keySearch;
    const _data = dataSearch.filter((item) => {
      return item.name.toLowerCase().includes(keySearch.toLowerCase());
    });
    setData(_data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openModelHistory = (ids: number | null) =>
    modals.openConfirmModal({
      title: <Title order={4}>Chỉnh sửa vai trò</Title>,
      size: "100%",
      children: <RolesEditView id={ids ?? 0} onLoad={fetchData} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
    });

  const openModelHistoryAdd = () =>
    modals.openConfirmModal({
      title: <Title order={4}>Thêm mới vai trò</Title>,
      size: "100%",
      children: <RolesAddView onLoad={fetchData} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
    });

  function progessTemplate(props: any): any {
    return (
      <>
        <Tooltip
          label="Chỉnh sửa thông tin"
          onClick={async (e) => {
            //RolesEditView
            await openModelHistory(props.original.id);
          }}
        >
          <ActionIcon variant="light" aria-label="Settings" color="cyan">
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Xóa">
          <ActionIcon
            onClick={async (e) => {
              modals.openConfirmModal({
                title: "Xóa",
                children: <>Bạn có thực sự muốn thao tác xóa !</>,
                labels: { confirm: "Xác nhận", cancel: "Hủy bỏ" },
                onCancel: () => console.log("Cancel"),
                onConfirm: async () => {
                  let urlCreate = `/api/v1/role/delete`;
                  const callapi = await repositorySign.post<
                    MessageResponse<RoleModel>
                  >(urlCreate, [props.original.id]);
                  if (callapi && callapi.httpStatusCode === 200) {
                    if (callapi.success) {
                      await fetchData();
                      NotificationExtension.Success("Xóa thành công !");
                    } else NotificationExtension.Fails("Xóa thất bại !");
                  }
                },
              });
            }}
            variant="light"
            aria-label="Settings"
            color="red"
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  const columns = React.useMemo<MRT_ColumnDef<RoleModelQuery>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },
      {
        accessorKey: "name",
        header: "Tên vai trò",
      },
      // {
      //   accessorKey: "by",
      //   header: "Người tạo",
      // },
      {
        accessorKey: "updatedAt",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row)}
          </Box>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: [
        //   "STT",
        //   "mrt-row-select",
        //   "mrt-row-expand",
        //   "orderNumber",
        //   "orderStatus",
        // ],
        // right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTable,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      // sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  //#endregion
  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Flex justify={"end"}>
            <Flex
              gap="md"
              justify={{ sm: "flex-start", lg: "flex-end" }}
              align="center"
              direction="row"
              wrap="wrap"
            >
              <Button
                leftSection={<IconPlus size={14} />}
                color="violet"
                variant="outline"
                onClick={async () => {
                  await openModelHistoryAdd();
                }}
              >
                Thêm mới
              </Button>
            </Flex>
          </Flex>
        </Flex>

        <form>
          <Grid>
            <Grid.Col span={_span}>
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <Button
                mt={"25px"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={handleSearch}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default RolesTable;
